import { type ReactNode } from "react";
import { FaTimes } from "react-icons/fa";
import { useLocalStorage } from "@reactuses/core";
import { Flex } from "../../../../styled-system/jsx";
import { css } from "../../../../styled-system/css";
import { type SystemStyleObject } from "../../../../styled-system/types";
import moment from "moment";

type Props = {
  storageKey: string;
  children: ReactNode;
  dismissForDays?: number;
  css?: SystemStyleObject;
};

const DismissibleBanner = ({ storageKey, children, css: cssProp, dismissForDays = Infinity }: Props) => {
  const [isBannerDismissed, setIsBannerDismissed] = useLocalStorage<string | null>(storageKey, null);

  if (
    isBannerDismissed &&
    (dismissForDays === Infinity || moment(isBannerDismissed).isAfter(moment().subtract(dismissForDays, "days")))
  ) {
    return null;
  }

  return (
    <Flex
      className={css({
        position: "relative",
        justifyContent: "center",
        borderBottom: "1px solid {colors.border.default}",
        paddingY: "large",
        color: "white",
        fontSize: "small",
        textAlign: "center",
        backgroundColor: "trellisPalette.2",
        ...cssProp,
      })}
    >
      {children}
      <button
        className={css({
          cursor: "pointer",
          position: "absolute",
          right: "20px",
          alignSelf: "center",
          border: "none",
          backgroundColor: "inherit",
        })}
        onClick={() => {
          setIsBannerDismissed(moment().format("YYYY-MM-DD"));
        }}
      >
        <FaTimes size={15} className={css({ color: "white" })} />
      </button>
    </Flex>
  );
};

export default DismissibleBanner;
